import type { ProfessionalTypeEnum } from '@gql/graphql';
import type { ReactNode } from 'react';
import type { ModalData } from '..';

export interface JoinProFormModalData {
  formComponent: ReactNode;
  modal: ModalData;
  type: ProfessionalTypeEnum;
}

export interface JoinProFormModalProps extends JoinProFormModalData {}
